import React, { ReactElement } from 'react';
import { ModalProps } from "../ModalContext";
import EmailForm from '../../../views/email/EmailForm';

export const handleSendEmail = async ({
    t,
    itemId,
    data,
    objectType,
    actionValue,
    initializeModal,
}: {
    t: (key: string, options?: any) => string,
    itemId: number,
    data: any;
    objectType: string,
    actionValue: string,
    initializeModal: (content: ReactElement<any>, props?: ModalProps, itemId?: number | null) => void; 
}) => {

    // Open the email form modal
    initializeModal(
        <EmailForm
            placement="modal"
            timeline_page="job"
            timeline_page_id={itemId}
            divisionId={data.division ?? null}
            connectedFeature={objectType}
            defaultTemplateType={actionValue}
            objectData={data}
        />,
        {
            title: t('email.general.compose_email_header'),
            modalSize: 'medium'
        }
    );      
};